import { createIcon } from '@chakra-ui/icons';

export const AZDescending = createIcon({
  displayName: 'AZDescending',
  viewBox: '0 0 12 12',
  path: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1096_22350)">
        <path
          d="M-0.125 4.875L1.5625 0.375H1.9375L3.625 4.875"
          stroke="currentColor"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.4375 3.375H3.0625"
          stroke="currentColor"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-0.125 7.125H3.625L-0.125 11.625H3.625"
          stroke="currentColor"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.125 0.375V11.625"
          stroke="currentColor"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.125 8.625L8.125 11.625L11.125 8.625"
          stroke="currentColor"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1096_22350">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
});
